import * as reactTracking from "react-tracking";

export const ReactTrackingContext = reactTracking.ReactTrackingContext;
export const track = reactTracking.track;
export const useTracking = reactTracking.useTracking;

export default reactTracking.default;
